import { BarangayList } from './AddressList/BarangayList';
import { CityMunicipalityList } from './AddressList/CityMunicipality';
import { ProvinceList } from './AddressList/ProvinceList';
import { ZipCodeList } from './AddressList/ZipCodeList';

export function formatTime(DataDate) {
  var event = new Date(DataDate);
  return event.toLocaleTimeString();
}

export function formatDateTime(DataDate) {
  const today = new Date(DataDate);
  let yr = today.getFullYear().toString().replace('-','');
  const date = yr + '-' + twoDigits(today.getMonth() + 1) + '-' + twoDigits(today.getDate());
  const time = twoDigits(today.getHours()) + ":" + twoDigits(today.getMinutes());
  return `${date}T${time}`;
}

function twoDigits(value) {
  if (value < 10) return `0${value}`;
  return value;
}

export function dateFormatData(date) {
  var d = new Date(date);
  var day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
  var newMonth = d.getMonth() + 1;
  var month = newMonth >= 10 ? newMonth : '0' + newMonth;
  var year = d.getFullYear().toString().replace('-','');
  return year + '-' + month + '-' + day;
}

export function dateFormatDisplay(date) {
  var day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
  var newMonth = date.getMonth() + 1;
  var month = newMonth >= 10 ? newMonth : '0' + newMonth;
  var year = date.getFullYear().toString().replace('-','');
  return month + '/' + day + '/' + year;
}

export function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);
  var interval = Math.floor(seconds / 31536000);
  if (interval > 1) {
    return interval + " years";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutes";
  }
  return Math.floor(seconds) + " seconds";
}

export const dateFormat = date => {
  var event = new Date(date);
  var options = { weekday: "short", year: "numeric", month: "short", day: "numeric" };
  return event.toLocaleDateString("eng", options);
};

export const dateFormatThree = date => {
  var event = new Date(date);
  var options = { year: "numeric", month: "short", day: "numeric" };
  return event.toLocaleDateString("eng", options);
};

export const FormatMonthYear = date => {
  var event = new Date(date);
  var options = { month: "long", year: "numeric", };
  return event.toLocaleDateString("eng", options);
};

export const FormatMonthDay = date => {
  var event = new Date(date);
  var options = { month: "short", day: "numeric" };
  return event.toLocaleDateString("eng", options);
};

export const dateFormatFour = date => {
  var event = new Date(date);
  var options = { year: "numeric", month: "long", day: "numeric" };
  return event.toLocaleDateString("eng", options);
};

export const dateTimeFormat = date => {
  var event = new Date(date);
  var options = { weekday: "short", year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric" };
  return event.toLocaleDateString("eng", options);
};

export const NewDateTimeFormat = date => {
  var event = new Date(date);
  var options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" };
  return event.toLocaleDateString("eng", options);
};

export const NewDateTimeFormatPlus8 = date => {
	var event = new Date(date);
	event.setHours(event.getHours() + 8);
	var options = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric" };
	return event.toLocaleDateString("eng", options);
};

export const millitaryTimeFormat = x => {
  var monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let date = new Date(x);
  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear().toString().replace('-','');
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return `${day}-${monthNames[monthIndex]}-${year} ${hour}:${min}H`;
};

export const millitaryTimeFormatLong = x => {
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let date = new Date(x);
  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear().toString().replace('-','');
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return `${monthNames[monthIndex]} ${day}, ${year} @${hour}:${min}H`;
};

export function formatDateLong(date) {
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  let current_datetime = new Date(date)
  var year = current_datetime.getFullYear().toString().replace('-','');
  let formatted_date = months[current_datetime.getMonth()] + " " + current_datetime.getDate() + ", " + year;
  return formatted_date;
}

export function formatDateShortMon(date) {
  const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  let current_datetime = new Date(date);
  var year = current_datetime.getFullYear().toString().replace('-','');
  let formatted_date = months[current_datetime.getMonth()] + " " + current_datetime.getDate() + ", " + year;
  return formatted_date;
}

export const millitaryTimeFormatNew = x => {
  let date = new Date(x);
  var day = date.getDate();
  var month = 1 + date.getMonth();
  var year = date.getFullYear().toString().replace('-','');
  var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return `${month}/${day}/${year} ${hour}:${min}`;
};

export function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  // var characters =
  //   "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function currencyFormat(n) {
  if (n && n > 0) {
    var val = 0;
    if(Number.isInteger(n)){
      val = n.toFixed(0).replace(/./g, function (c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
      });
    }
    else {
      val = n.toFixed(2).replace(/./g, function (c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
      });
    }
    return val;
  }
  else {
    return '0';
  }
}

export function currencyFormatSQ(n) {
  let num = Math.sign(n);
  if(num > 0){
    var val = n.toFixed(2).replace(/./g, function (c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    });
    return val;
  }
  else if(num < 0){
    var val = n.toFixed(2).replace(/./g, function (c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    });
    return val;
  }
  else {
    return '0.00';
  }
}

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
      return -1;
  }
  if (b[orderBy] > a[orderBy]) {
      return 1;
  }
  return 0;
}
export function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}
export function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export function SpecificSort(data, SortList, keyname) {
	return data.sort((a, b) => {
		return (
			SortList.indexOf(a[keyname]) - SortList.indexOf(b[keyname])
		);
	});
}

export function SpecificSortNoItem(data, SortList) {
	return data.sort((a, b) => {
		return (
			SortList.indexOf(a) - SortList.indexOf(b)
		);
	});
}

export const isMobile = {
  Android: function () {
      return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
      return navigator.userAgent.match(/Mac|iPhone|iPad|iPod/i);
  },
  Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
      return navigator.userAgent.match(/IEMobile|Window|Linux/i);
  },
  any: function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

export function getBase64(file, cb) {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
      cb(reader.result)
  };
  reader.onerror = function (error) {
      console.log('Error: ', error);
  };
}

export function search_word(text, word) {
  var x = 0, y=0;
  for (var i=0;i< text.length;i++)
      {
      if(text[i] === word[0])
          {
          for(var j=i;j< i+word.length;j++)
             {
              if(text[j] === word[j-i])
                {
                  y++;
                }
              if (y === word.length){
                  x++;
              }
          }
          y=0;
      }
  }
 return x > 0 ? word : 'Not';
}

export function CapFirst(val) {
    return val.charAt(0).toUpperCase() + val.slice(1)
}

export function GetUnique(doc, name) {
  const result = [];
  const map = new Map();
  if(doc && doc.length > 0){
      // eslint-disable-next-line
      for (const item of doc) {
          if (!map.has(item[name])) {
              map.set(item[name], true);    // set any value to Map
              result.push(item[name]);
          }
      }
  }
  return result;
}

export function GetUniqueData(doc, name) {
  const result = [];
  const map = new Map();
  if(doc && doc.length > 0){
      // eslint-disable-next-line
      for (const item of doc) {
          if (!map.has(item[name])) {
              map.set(item[name], true);    // set any value to Map
              result.push(item);
          }
      }
  }
  return result;
}

export function GetUniqueDataItem(doc) {
  const result = [];
  const map = new Map();
  if(doc && doc.length > 0){
      // eslint-disable-next-line
      for (const item of doc) {
          if (!map.has(item)) {
              map.set(item, true);    // set any value to Map
              result.push(item);
          }
      }
  }
  return result;
}

export const toDataURL = url => fetch(url)
.then(response => response.blob())
.then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
}))

export function numberToLetters(num) {
  let letters = ''
  while (num >= 0) {
      letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
      num = Math.floor(num / 26) - 1
  }
  return letters
}

export function stringNumbertoFloat(value) {
	let result = 0;
	if(value && value !== "" && parseFloat(value) > 0){
		result = parseFloat(value.toString().replace(/,/g, ''));
	}
	return result;
}

//#region Search Address
export function handleProvince(val) {
  let province = [];
  if(ProvinceList && ProvinceList.length > 0){
      if(val && val !== ""){
          province =  ProvinceList.filter(o => o && o.toUpperCase().includes(val.toUpperCase()));
      }
      else {
          province = ProvinceList;
      }
  }
  return province;
}

export function handleCity(province, val) {
  let city = [];
  if(province && province !== ""){
      let findPro = CityMunicipalityList.find(d => d.province && d.province && d.province.toUpperCase().includes(province.toUpperCase()));
      if(findPro){
          if(findPro.cityList && findPro.cityList.length > 0){
              if(val && val !== ""){
                  city =  findPro.cityList.filter(o => o.toUpperCase().includes(val.toUpperCase()));
              }
              else {
                  city = findPro.cityList;
              }
          }
      }
  }
  return city;
}

export function handleBarangay(province, city, val) {
  let barangay = [];
  if(province && province !== "" && city && city !== ""){
      let findProCt = BarangayList.find(d => d.province && d.province.toUpperCase().includes(province.toUpperCase()) && d.city && d.city.toUpperCase().includes(city.toUpperCase()));
      if(findProCt){
          if(findProCt.barangayList && findProCt.barangayList.length > 0){
              if(val && val !== ""){
                  barangay =  findProCt.barangayList.filter(o => o.toUpperCase().includes(val.toUpperCase()));
              }
              else {
                  barangay = findProCt.barangayList;
              }
          }
      }
  }
  return barangay;
}

export function handleZipCode(province, city) {
  let zipCode = "";
  if(province && province !== "" && city && city !== ""){
      let findZip = ZipCodeList.find(d => d.province && d.province.toUpperCase().includes(province.toUpperCase()) && d.city && d.city.toUpperCase().includes(city.toUpperCase()))
      if(findZip){
        zipCode = findZip.zipCode;
      }
  }
  return zipCode;
}
//#endregion